/**
 * Effect Run show — `[PROPOSED]` Inspector-grammar teaser at
 * `/effect-runs/:id`. Full grammar shell; the one relation is the parent
 * RuleRun (`frontend-entity-coverage §2.3`). No primary verb beyond inspection.
 * Never hard-errors a show page.
 */
import { useParams } from "react-router-dom";

import {
  Inspector,
  InspectorHeader,
  InspectorSection,
  Field,
  FieldGrid,
  RelationsBlock,
  AuditBlock,
  TechnicalId,
} from "@/components/inspector";
import { ProposedShowTeaser, BackToList } from "../_shared/ProposedModule";

export function EffectRunShow() {
  const { id } = useParams<{ id: string }>();

  return (
    <Inspector>
      <InspectorHeader
        title="Effect Run"
        subtitle="One effect a rule fired — its payload and outcome."
        status="proposed"
        actions={<BackToList to="/effect-runs" label="Effect runs" />}
      />

      <InspectorSection title="Overview">
        <FieldGrid>
          <Field label="Effect type" />
          <Field label="Status" />
          <Field label="Result" />
        </FieldGrid>
      </InspectorSection>

      <InspectorSection title="Body">
        <ProposedShowTeaser endpoint="/api/effect-runs" />
      </InspectorSection>

      <InspectorSection title="Relations">
        <RelationsBlock
          groups={[
            {
              title: "References",
              emptyMessage: "The parent Rule Run appears once this ships.",
              items: [],
            },
          ]}
        />
      </InspectorSection>

      <InspectorSection title="Technical">
        <FieldGrid className="text-muted-foreground">
          <Field label="Id">
            <TechnicalId id={String(id)} />
          </Field>
        </FieldGrid>
      </InspectorSection>

      <InspectorSection title="Audit">
        <AuditBlock entityType="effect-runs" entityId={id} />
      </InspectorSection>
    </Inspector>
  );
}

export default EffectRunShow;
